import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const CopilotIconGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4952 8.58524C12.4952 7.80746 12.2475 7.08752 11.8267 6.5H16.4498C16.864 6.5 17.1998 6.16421 17.1998 5.75C17.1998 5.33579 16.864 5 16.4498 5H8.92039L8.91475 5.00002L8.90996 5.00002C6.9299 5.00002 5.32474 6.60517 5.32474 8.58524C5.32474 10.5653 6.9299 12.1705 8.90996 12.1705C10.89 12.1705 12.4952 10.5653 12.4952 8.58524ZM0 5.75011C0 5.33589 0.335786 5.00011 0.75 5.00011H4.73801C5.15223 5.00011 5.48801 5.33589 5.48801 5.75011C5.48801 6.16432 5.15223 6.50011 4.73801 6.50011H0.75C0.335786 6.50011 0 6.16432 0 5.75011ZM4.51598 11.5404C4.93019 11.5404 5.26598 11.2047 5.26598 10.7904C5.26598 10.3762 4.93019 10.0404 4.51598 10.0404H2.62583C2.21162 10.0404 1.87583 10.3762 1.87583 10.7904C1.87583 11.2047 2.21162 11.5404 2.62583 11.5404H4.51598ZM8.90996 6.50002C7.75833 6.50002 6.82474 7.4336 6.82474 8.58524C6.82474 9.73687 7.75833 10.6705 8.90996 10.6705C10.0616 10.6705 10.9952 9.73687 10.9952 8.58524C10.9952 7.4336 10.0616 6.50002 8.90996 6.50002ZM13.2689 10.0404C12.8547 10.0404 12.5189 10.3762 12.5189 10.7904C12.5189 11.2047 12.8547 11.5404 13.2689 11.5404H15.1591C15.5733 11.5404 15.9091 11.2047 15.9091 10.7904C15.9091 10.3762 15.5733 10.0404 15.1591 10.0404H13.2689Z"
        fill={fillColor}
      />
    </g>
  );
};

export const CopilotIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <CopilotIconGroup {...props} />
    </svg>
  );
};
